import React from "react";
import Card from "react-bootstrap/Card";
import ShowMoreText from "react-show-more-text";
import projImg8 from "../../assets/img/8.png";
import projectimage11 from "../../assets/img/p11.png";

const PreviousCard11 = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Analysing political networks in the European Parliament</h2></Card.Title> */}
        <Card.Img variant="top" src={projectimage11} />

        <Card.Body>
          <Card.Text>
            {" "}
            <img className="img2" src={projImg8} />{" "}
            <p className="text7">Attila Kovács </p>
            <br />
            <p className="text8">
              Dean
              <br /> Budapest Metropolitan University
            </p>
          </Card.Text>
          <ShowMoreText lines={2}>
            <div>
              Legislative data could be used to identify key legislators
              and decision-makers in EU policies and politics and to
              quantify their influence on legislative outcome (Kreppel,
              1999). Co-voting and co-sponsorship networks could be drawn
              up and analysed by social network analysing tools, giving
              insights to what networks and coalitions of elected members
              have a high impact on the legislative outcome in the EU (Hix
              et al., 2009). This is a valuable information for EU
              citizens and lobbying companies as well (Marschall, 2010).
              Homophily could give answers to what drives cooperation in
              political networks in Brussels (McPherson et al., 2001).
              Analysing legislative amendments or parliamentary speeches
              using natural language processing could be another potential
              research area of interest. A unique dataset of more than 1
              million legislative amendments and parliamentary speeches
              since 2009 could be the basis of analysis. All this broken
              down by policy area and legislative procedure type. The
              dataset also contains a number of variables related to the
              amendments and their sponsors (age, gender, ideological
              scores, party affiliation, Member State, education level,
              etc.). It also broadens the diversity of potential research
              avenues.
              <br />
              <br />
              Related literature:{" "}
              <ul>
                <li>
                  McPherson, M., Smith-Lovin, L. and Cook, J.M. (2001).
                  Birds of a Feather: Homophily in Social Networks.
                  <span className="text9"> Annu. Rev. Sociol. </span> 2001.
                  27:415–44.{" "}
                </li>

                <li>
                  Marshall, D. (2010). Who to lobby and when:
                  Institutional determinants of interest group strategies
                  in European Parliament committees.
                  <span className="text9"> European Union Politics. </span>{" "}
                  11(4) 553–575.{" "}
                </li>

                <li>
                  Hix, S., Noury, A. and Roland, G. (2009). Voting
                  patterns and alliance formation in the European
                  Parliament.{" "}
                  <span className="text9"> Phil. Trans. R. Soc. B. </span> 364,
                  821–831.{" "}
                </li>

                <li>
                  Kreppel, A. (1999). What Affects the European
                  Parliament’s Legislative Influence? An Analysis of the
                  Success of EP Amendments.
                  <span className="text9">
                    {" "}
                    Journal of Common Market Studies.{" "}
                  </span>{" "}
                  37(3): 521–38.{" "}
                </li>

                <li>
                  Fertő, I., Kóczy, L.Á., Kovács, A. and Sziklai, B.R.
                  (2020). The power ranking of the members of the
                  Agricultural Committee of the European Parliament.{" "}
                  <span className="text9">
                    {" "}
                    European Review of Agricultural Economics{" "}
                  </span>
                  . 47(5): 1897–1919
                </li>
              </ul>
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>

    );
};

export default PreviousCard11;
